/**
 * API base URL for backend requests.
 *
 * Priority:
 * 1. process.env.REACT_APP_API_URL (build-time)
 * 2. window.NYUFAZ_API_URL / window.REACT_APP_API_URL
 * 3. Local CRA/Vite dev (3000/3010/5173): empty string → same-origin + setupProxy
 *    (avoids CORS when calling :5006 cross-origin)
 * 4. window.location.origin
 */
const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5006';

function isLocalDevFrontend(origin) {
  if (!origin) return false;
  try {
    const { hostname, port } = new URL(origin);
    const isDevPort = port === '3010' || port === '3000' || port === '5173';
    const isLocalHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.startsWith('192.168.') ||
      hostname.startsWith('10.');
    return isLocalHost && isDevPort;
  } catch {
    return false;
  }
}

export function getApiBaseUrl() {
  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const fromWindow = window.NYUFAZ_API_URL || window.REACT_APP_API_URL;
    if (fromWindow && String(fromWindow).trim()) return String(fromWindow).trim().replace(/\/$/, '');
    const origin = window.location && window.location.origin;
    // Same-origin in local CRA so requests go through the proxy (no CORS).
    if (isLocalDevFrontend(origin)) {
      return '';
    }
    if (origin) return origin;
  }

  return '';
}

/** Absolute base when a direct :5006 URL is required. */
export function getDirectHairApiBaseUrl() {
  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim().replace(/\/$/, '');
  if (typeof window !== 'undefined') {
    try {
      const { hostname } = new URL(window.location.origin);
      return `http://${hostname}:5006`;
    } catch {
      return DEFAULT_DEV_API_ORIGIN;
    }
  }
  return DEFAULT_DEV_API_ORIGIN;
}

/** Build full URL for a hair API path (resolves base URL at call time). */
export function buildHairApiUrl(path) {
  const base = (getApiBaseUrl() || '').replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}

export const Hair_API_PREFIX = '/api/hair';
